export const EamMessagesValue = {
  apis: {
    serviceError: `Unfortunately, there seems to be an error.`
  },
};
